var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f7f7f7;}.b{fill:#21a366;}.c{fill:#185c37;}.d{fill:#107c42;}.e{fill:#3fa071;}.f{fill:#33c481;}.g{opacity:0.05;}.h{opacity:0.07;}.i{opacity:0.09;}.j{fill:url(#a);}.k{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.036,
    y1: 0.036,
    x2: 0.953,
    y2: 0.953,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18884f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b6731"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1214 -537)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 36.5,
    cy: 36,
    rx: 36.5,
    ry: 36,
    transform: "translate(1214 537)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1227 549)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 16,
    height: 9,
    transform: "translate(28 15)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M44,24H12V40a2,2,0,0,0,2,2H42a2,2,0,0,0,2-2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 16,
    height: 9,
    transform: "translate(28 24)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 16,
    height: 9,
    transform: "translate(12 15)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M42,6H28v9H44V8A2,2,0,0,0,42,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14,6H28v9H12V8A2,2,0,0,1,14,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M22.319,13H12V37H22.319A3.681,3.681,0,0,0,26,33.319V16.681A3.681,3.681,0,0,0,22.319,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M22.213,36H12V13.333H22.213a3.121,3.121,0,0,1,3.121,3.121V32.879A3.122,3.122,0,0,1,22.213,36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M22.106,35H12V13.667H22.106a2.56,2.56,0,0,1,2.56,2.56V32.44A2.559,2.559,0,0,1,22.106,35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M22,34H6a2,2,0,0,1-2-2V16a2,2,0,0,1,2-2H22a2,2,0,0,1,2,2V32A2,2,0,0,1,22,34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M9.807,19h2.386l1.936,3.754L16.175,19H18.4l-3.071,5,3.141,5H16.123l-2.11-3.93L11.912,29H9.526l3.193-5.018Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.3dbcc25e.svg";
export { ForwardRef as ReactComponent };